module.exports = __webpack_public_path__ + "static/media/link.4b20bedf.svg";